import { InputAdornment, TextFieldProps } from '@mui/material';
import { COLORS } from '../../../themes/colors';
import Icon from '../../Icon';
import { IconName } from '../../Icon/types';
import {
  ErrorIcon,
  ErrorMessage,
  StyledTextInput,
  SuccessIcon,
} from '../styles';

type UncontrolledTextInputProps = TextFieldProps & {
  errorMessage?: string;
  mask?: Function;
  iconStart?: IconName;
  iconEnd?: IconName;
};

const UncontrolledTextInput = ({
  variant = 'filled',
  color,
  error,
  InputProps,
  FormHelperTextProps,
  value,
  onChange,
  errorMessage,
  mask,
  iconStart,
  iconEnd,
  required,
  ...props
}: UncontrolledTextInputProps) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = e.target;

    if (mask) e.target.value = mask(value);

    onChange?.(e);
  };

  return (
    <>
      <StyledTextInput
        color={color}
        error={error}
        required={required}
        onChange={handleChange}
        value={value}
        variant={variant}
        InputLabelProps={{
          style: {
            fontSize: 14,
            ...(required && { color: COLORS.PRIMARY.BLUE['+1'] }),
          },
        }}
        FormHelperTextProps={{
          ...FormHelperTextProps,
          ...(color === 'success' && {
            style: {
              color: COLORS.SECONDARY.GREEN['+1'],
            },
          }),
        }}
        InputProps={{
          ...InputProps,
          required,
          ...(color === 'success' && {
            endAdornment: (
              <InputAdornment position="end">
                <SuccessIcon name="check" />
              </InputAdornment>
            ),
          }),
          ...(error && {
            endAdornment: (
              <InputAdornment position="end">
                <ErrorIcon name="alert" />
              </InputAdornment>
            ),
          }),
          ...(iconStart && {
            startAdornment: (
              <InputAdornment position="end">
                <Icon name={iconStart} size={24} />
              </InputAdornment>
            ),
          }),
          ...(iconEnd && {
            endAdornment: (
              <InputAdornment position="end">
                <Icon name={iconEnd} size={24} />
              </InputAdornment>
            ),
          }),
        }}
        {...props}
      />
      {errorMessage && error && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  );
};

export default UncontrolledTextInput;
